import { motion } from "framer-motion";
import Slider from "rc-slider";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import TroopBox from "../../components/Boxes/TroopBox";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import networkInstance from "../../redux/api/Network";
import ThousandsSeparator from "../../utils/thousands-separator";

type Props = {};

const Troops = (props: Props) => {
  const { t } = useAppTranslation("learn");
  const [data, setData] = React.useState([]);
  const [level, setLevel] = useState(1);
  const [loading, setLoading] = useState(true);
  const [viewType, setViewType] = useState(
    +localStorage.getItem("card-sort")! || 1
  );

  const handleGetTroops = async () => {
    setLoading(true);
    const response = await networkInstance.CallApi({
      url: "/troop/levels",
      method: "get",
    });
    setData(
      response.data?.map((res) => ({
        ...res,
        abilities: res.abilities ? JSON.parse(res.abilities) : undefined,
      }))
    );
    setLoading(false);
  };

  useEffect(() => {
    handleGetTroops();
  }, []);

  return (
    <div>
      <div className="text-secondary mt-4 text-center">
        {t("learn:troops.description")}
      </div>
      <div className="d-flex mb-3 justify-content-between align-items-center py-4">
        <div style={{ maxWidth: 600 }} className="w-100 ">
          <Slider
            step={1}
            value={level}
            onChange={(val) => setLevel(val as number)}
            max={15}
            min={1}
            marks={{
              1: 1,
              2: 2,
              3: 3,
              4: 4,
              5: 5,
              6: 6,
              7: 7,
              8: 8,
              9: 9,
              10: 10,
              11: 11,
              12: 12,
              13: 13,
              14: 14,
              15: 15,
            }}
          />
        </div>

        <motion.div
          initial={isMobile ? undefined : { opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{
            duration: 0.4,
          }}
          exit={{ x: -window.innerWidth, opacity: 0 }}
          className="d-flex align-items-center ms-3 justify-content-end mt-1  "
        >
          <div
            onClick={() => {
              setViewType(1);
              localStorage.setItem("card-sort", "1");
            }}
            className={`sort-btn ${viewType === 1 && "active"}`}
          >
            <img
              alt="grid"
              width={22}
              height={22}
              src="/assets/images/icons/grid.png"
            />
          </div>
          <div
            onClick={() => {
              setViewType(2);
              localStorage.setItem("card-sort", "2");
            }}
            className={`ms-2 sort-btn  ${viewType === 2 && "active"}`}
          >
            <img
              alt="grid2x"
              width={22}
              height={22}
              src="/assets/images/icons/grid2x.png"
            />
          </div>
        </motion.div>
      </div>

      <div className="row">
        {loading &&
          [1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
            <div
              key={index + "loading"}
              className="col-xl-3 col-lg-4 col-sm-6 col-12"
            >
              <TroopBox loading type={viewType} />
            </div>
          ))}
        {!loading &&
          data?.map((troop: any, index) => {
            const currentTroop = troop.playerTroops.find(
              (trp) => trp.level === level
            );
            return (
              <div key={index} className="col-xl-3 col-lg-4 col-sm-6 col-12">
                <TroopBox
                  {...troop}
                  troop={troop}
                  isLearn
                  type={viewType}
                  level={level}
                  damage={ThousandsSeparator(currentTroop.damage)}
                  armor={ThousandsSeparator(currentTroop.armor)}
                  clegCost={ThousandsSeparator(
                    Math.pow(2, level - 1) * troop.clegCost
                  )}
                  ironCost={ThousandsSeparator(
                    Math.pow(2, level - 1) * troop.ironCost
                  )}
                  stoneCost={ThousandsSeparator(
                    Math.pow(2, level - 1) * troop.stoneCost
                  )}
                  magicResistance={ThousandsSeparator(
                    currentTroop.magicResistance
                  )}
                  range={ThousandsSeparator(currentTroop.range)}
                  health={currentTroop.maxHealth}
                  maxHealth={currentTroop.maxHealth}
                  abilities={
                    currentTroop.abilities
                      ? JSON.parse(currentTroop.abilities)
                      : troop.abilities
                  }
                />
              </div>
            );
          })}
      </div>
      <div className="text-white mt-5">
        <div>
          {t("learn:troops.xpRules")}
        </div>

        <div className="mt-4">
          <h2>{t("learn:troops.sections.mergingUnit.title")}</h2>
          <p>{t("learn:troops.sections.mergingUnit.body")}</p>
          <h2>{t("learn:troops.sections.damageResistance.title")}</h2>
          <p>{t("learn:troops.sections.damageResistance.body")}</p>
        </div>
        <div className="text-center mt-5">
          <img
            alt={t("learn:troops.chart.alt")}
            className="rounded "
            src="/assets/images/troop-chart.jpg"
            style={{ maxWidth: 900 }}
          />
          <div className="fs-med mt-2 text-secondary">
            {t("learn:troops.chart.caption")}
          </div>
        </div>
        <div className="mt-4 text-med lh-lg">
          {t("learn:troops.formula.title")}
          <br />
          {t("learn:troops.formula.physicalFormula")}
          <br />
          {t("learn:troops.formula.exampleIntro")}
          <br />
          {t("learn:troops.formula.exampleCalc")}
          <br />
          {t("learn:troops.formula.magicIntro")}
          <br />
          {t("learn:troops.formula.magicFormula")}
        </div>
      </div>
    </div>
  );
};

export default Troops;
